export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const OTEL_EXPORTER_OTLP_ENDPOINT =
  process.env.REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT;
export const MQTT_URL = process.env.REACT_APP_MQTT_URL;
export const G_POS_VERSION = process.env.REACT_APP_G_POS_VERSION;
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
export const REACT_APP_API_PAYMENT_URL = process.env.REACT_APP_API_PAYMENT_URL;
export const REACT_APP_DEEP_LINK = process.env.REACT_APP_DEEP_LINK;
export const TGS_AVATAR_BASE_URL =
  process.env.REACT_APP_TGS_AVATAR_BASE_URL;
export const APP_LOGIN_STATE_STORAGE_KEY = "qrOrderAppLoginState";
export const APP_LOGIN_RETURN_PATH_STORAGE_KEY = "qrOrderAppLoginReturnPath";
export const APP_LOGIN_CALLBACK_PATH = "/app-login-callback";
export const APP_LOGIN_CALLBACK_WARNING = {
  SESSION_EXPIRED: "session-expired",
  NO_INTERNET: "no-internet",
  API_ERROR: "api-error",
};
